<template>
  <div
    v-if="visible"
    class="absolute h-[100vh] inset-0 z-50 flex flex-col items-center justify-top bg-white/70 backdrop-blur-sm"
  >
    <div class="bg-white bg-opacity-90 rounded-lg p-8 shadow-lg flex flex-col items-center mt-16">
      <span class="text-2xl font-bold text-red-600 mb-2">Accès réservé</span>
      <p class="mb-4 text-center">
        <template v-if="reason === 'plan'">
          Votre forfait actuel ne permet pas d'accéder à cette page.<br>
          <span class="font-semibold">Passez à un forfait supérieur pour débloquer cette fonctionnalité.</span>
        </template>
        <template v-else-if="reason === 'permission'">
          Vous n'avez pas les droits nécessaires pour accéder à cette page.<br>
          <span class="font-semibold">Contactez l'administrateur de votre compte pour obtenir l'accès.</span>
        </template>
        <template v-else>
          Accès non autorisé.
        </template>
      </p>
      <router-link v-if="reason === 'plan'" to="/account" class="callToAction px-6 py-2 hover:underline">Changer de forfait</router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    reason: {
      type: String,
      default: "plan" // "plan" ou "permission"
    }
  },
  watch: {
    visible(val) {
      document.body.style.overflow = val ? "hidden" : "";
    }
  },
  mounted() {
    if (this.visible) {
      document.body.style.overflow = "hidden";
    }
  },
  beforeUnmount() {
    document.body.style.overflow = "";
  }
}
</script>